import { FeaturedWorkout } from 'src/dao/core-dao'
import { coreService } from 'src/service/core-service'
import { queryKeys } from 'src/util/query-keys'
import { useQuery } from '@tanstack/react-query'

type UseFeaturedWorkoutsReturnType = {
  featuredWorkouts: FeaturedWorkout[]
  isLoading: boolean
}

/**
 * The permanently-free workout set. Used unchanged by both consumers — the Home shelf and the
 * public login-page shelf — which is why it reaches for no session state of any kind: the
 * login page renders outside `SessionContext`.
 *
 * **The order is the server's.** It sorts shortest-to-longest so web and mobile cannot drift
 * on what that means; re-sorting here would reintroduce exactly the divergence that avoids.
 */
export const useFeaturedWorkouts = (): UseFeaturedWorkoutsReturnType => {
  const { data: featuredWorkouts = [], isLoading } = useQuery<FeaturedWorkout[], Error>(
    queryKeys.featuredWorkouts(),
    () => coreService.getFeaturedWorkouts(),
    { refetchOnWindowFocus: false },
  )

  return { featuredWorkouts, isLoading }
}
